import { render } from "./ActivePass.vue?vue&type=template&id=ce322922&scoped=true"
import script from "./ActivePass.vue?vue&type=script&lang=js"
export * from "./ActivePass.vue?vue&type=script&lang=js"

import "./ActivePass.vue?vue&type=style&index=0&id=ce322922&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce322922"]])

export default __exports__